import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const LinkContainer = styled(Link)`
    text-decoration: none;
    display: block;
`
export const NonLinkContainer = styled(Box)`
`